// api.ts
import axios from 'axios'
import endpoints from '../../endpoints'
import {InspectionReportBase, InspectionReportPayload} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchInspectionReport(
  payload: InspectionReportPayload
): Promise<APIResponse<InspectionReportBase[]>> {
  const response = await axios.post(API_URL + endpoints.reports.inspectionReport, payload)
  return response.data
}
